"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var TeamNavigation = /** @class */ (function (_super) {
    __extends(TeamNavigation, _super);
    function TeamNavigation(props) {
        var _this = _super.call(this, props) || this;
        _this.buildList = function (links, level, link) {
            for (var l = 0; l < links.length; l += 1) {
                var obj = links[l];
                obj.heading = obj.title;
            }
            var linksLength = links.length;
            linksLength -= 1;
            return (React.createElement("ul", { className: "list-reset flex w-full lg:flex-row flex-col level-" + level + " lg:items-center content-start justify-start lg:-mx-0-8 lg:pb-0 pb-18", style: {
                    height: "56px"
                } }, links
                ? links.map(function (link, i) {
                    var children = link.links && link.links.length;
                    var lastChild = i == linksLength;
                    var firstChild = i == 0;
                    var linkLogo = link.navigation_logo && link.navigation_logo.logo ? link.navigation_logo.logo : false;
                    return (React.createElement("li", { key: i, className: "flex-1 " + (firstChild ? "lg:pr-0-8 pr-1-6 lg:pl-0 pl-1-6" : "") + " " + (lastChild ? "lg:pl-0-8 pl-1-6" : "") + "\n                  " + (!firstChild && !lastChild ? "lg:px-0-8 px-1-6" : null) + " md:hover:bg-navy ", onMouseEnter: function () { return _this.handleHovers(true, link.handle); }, onMouseLeave: function () { return _this.handleHovers(false, link.handle); } },
                        React.createElement("a", { href: link.url, className: "lg:block flex items-center lg:border-none border-b border-grey-light" },
                            linkLogo && React.createElement("img", { src: linkLogo, alt: "teamlogo", className: "w-full h-full max-w-6" }),
                            React.createElement("span", { className: "lg:hidden text-base text-navy-dark leading-normal pl-1-6" }, link.title)),
                        children && _this.buildSubList(link.links, link.handle, link.title, linkLogo, link.url)));
                })
                : null));
        };
        _this.buildLink = function (links) { return (React.createElement("ul", { className: "list-reset" }, links.map(function (link, i) { return (React.createElement("li", { key: i, className: "link w-11 mb-0-6" },
            React.createElement("a", { href: link.url, className: "text-base leading-normal text-grey-dark" }, link.title))); }))); };
        _this.buildSubList = function (links, parentHandle, parentTitle, parentLogo, parentUrl) {
            for (var l = 0; l < links.length; l += 1) {
                var obj = links[l];
                obj.heading = obj.title;
            }
            return (React.createElement("section", { className: "absolute pin-t:100 pin-x z-50 transition-fast " + parentHandle + " " + _this.state.active + " " + (_this.state.active && _this.state.active == parentHandle
                    ? "opacity-100 visible pointer-events-auto"
                    : "opacity-0 invisible pointer-events-none") },
                React.createElement("div", { className: "bg-midnight-95" },
                    React.createElement(Snippets.Container, { width: "xl", className: "mlg:pl-11 md:pl-2-4" },
                        React.createElement("div", { className: "flex" },
                            React.createElement("div", { className: "flex justify-end w-1/4 lg:pr-8 md:pr-4 py-4 text-center max-h-40" },
                                React.createElement("div", { className: "" },
                                    parentLogo && React.createElement("img", { src: parentLogo, width: 200, height: 200, alt: parentLogo }),
                                    React.createElement("h4", { className: "font-semibold text-arctic mb-1-6 text-xmd" }, parentTitle),
                                    React.createElement(Snippets.Button, { href: parentUrl, style: "secondary", className: "mb-2-1 w-full font-bold text-xs max-w-21-2 uppercase py-1-4" }, "Shop All Products"))),
                            React.createElement("div", { className: "bg-arctic w-3/4" },
                                React.createElement("div", { className: "bg-arctic list-reset flex flex-wrap px-5-6 py-4 h-50 flex-col" }, links
                                    ? links.map(function (link, i) {
                                        var subChildren = link.links && link.links.length;
                                        return (React.createElement("div", { key: i, className: "link table " + (subChildren ? "mb-2" : "mb-0") },
                                            React.createElement("a", { href: link.url, className: "text-xs uppercase mb-0-8 tracking-wideless font-semibold leading-normal" }, link.title),
                                            subChildren && _this.buildLink(link.links)));
                                    })
                                    : null))))),
                React.createElement("div", { className: "h-full-h absolute pin bg-navy-dark-50", style: { top: "100%" } })));
        };
        _this.state = {
            active: null,
            activeDrop: null,
            previousDrop: null,
        };
        return _this;
    }
    TeamNavigation.prototype.render = function () {
        var _a = this.props, id = _a.id, linklist = _a.linklist;
        return (React.createElement("nav", { id: id, className: this.props.className }, linklist && linklist.links ? this.buildList(linklist.links, 0, null) : null));
    };
    TeamNavigation.prototype.handleHovers = function (status, id) {
        var _this = this;
        status
            ? this.setState({
                active: id,
            })
            : (this.setState({
                active: null,
                previousDrop: id,
            }),
                setTimeout(function () { return (_this.state.previousDropdown == id
                    ? _this.setState({
                        previousDrop: null,
                    })
                    : null); }, 500));
    };
    return TeamNavigation;
}(React.PureComponent));
exports.TeamNavigation = TeamNavigation;
